import { render, staticRenderFns } from "./InventoryTransferQuantityDialog.vue?vue&type=template&id=502791f2&"
import script from "./InventoryTransferQuantityDialog.vue?vue&type=script&lang=js&"
export * from "./InventoryTransferQuantityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports